import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white text-slate-600" }
const _hoisted_2 = { class: "border-t border-slate-100" }
const _hoisted_3 = { class: "max-w-7xl mx-auto px-4 lg:px-6 py-6 md:py-8" }
const _hoisted_4 = { class: "flex flex-col md:flex-row md:items-center md:justify-between gap-6 text-center md:text-left" }
const _hoisted_5 = { class: "flex flex-col items-center md:items-start gap-3" }
const _hoisted_6 = { class: "text-slate-500 text-[13px] md:text-[14px]" }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = {
  href: "https://facebook.com/vehitraworld",
  target: "_blank",
  rel: "noopener",
  class: "inline-flex h-9 w-9 items-center justify-center rounded-full ring-1 ring-slate-200 bg-white hover:bg-slate-50 transition",
  "aria-label": "Facebook"
}
const _hoisted_9 = {
  href: "https://instagram.com/vehitraworld",
  target: "_blank",
  rel: "noopener",
  class: "inline-flex h-9 w-9 items-center justify-center rounded-full ring-1 ring-slate-200 bg-white hover:bg-slate-50 transition",
  "aria-label": "Instagram"
}
const _hoisted_10 = {
  href: "https://x.com/vehitraworld",
  target: "_blank",
  rel: "noopener",
  class: "inline-flex h-9 w-9 items-center justify-center rounded-full ring-1 ring-slate-200 bg-white hover:bg-slate-50 transition",
  "aria-label": "Twitter"
}
const _hoisted_11 = {
  href: "https://www.linkedin.com/company/vehitraworld",
  target: "_blank",
  rel: "noopener",
  class: "inline-flex h-9 w-9 items-center justify-center rounded-full ring-1 ring-slate-200 bg-white hover:bg-slate-50 transition",
  "aria-label": "LinkedIn"
}
const _hoisted_12 = { class: "flex flex-wrap justify-center md:justify-start items-center gap-x-6 gap-y-3 uppercase text-[13px] tracking-wide" }

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookF, faInstagram, faXTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const year = new Date().getFullYear()
library.add(faFacebookF, faInstagram, faXTwitter, faLinkedinIn)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _cache[7] || (_cache[7] = _createStaticVNode("<section class=\"bg-slate-100/70\" data-v-668b68a0><div class=\"max-w-7xl mx-auto px-4 lg:px-6 py-8\" data-v-668b68a0><div class=\"grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8\" data-v-668b68a0><div class=\"flex items-start gap-4\" data-v-668b68a0><div class=\"relative shrink-0\" data-v-668b68a0><div class=\"w-12 h-12 rounded-full bg-white shadow-sm\" data-v-668b68a0></div><span class=\"font-icon theme-icon address-icon text-slate-400 absolute -top-2 -left-1 text-[40px] leading-none\" data-v-668b68a0></span></div><div data-v-668b68a0><h3 class=\"text-green-700 tracking-wide uppercase text-xs font-semibold\" data-v-668b68a0>Address</h3><a href=\"https://maps.google.com/?q=312 Falcon Tower Diplomatic Area, Manama, Kingdom of Bahrain\" target=\"_blank\" rel=\"noopener\" class=\"mt-1 block text-slate-800 font-medium text-[15px] leading-snug hover:underline\" data-v-668b68a0> 312 Falcon Tower Diplomatic Area, <br data-v-668b68a0> Manama, Kingdom of Bahrain </a></div></div><div class=\"flex items-start gap-4\" data-v-668b68a0><div class=\"relative shrink-0\" data-v-668b68a0><div class=\"w-12 h-12 rounded-full bg-white shadow-sm\" data-v-668b68a0></div><span class=\"font-icon theme-icon tel-icon text-slate-400 absolute -top-2 -left-1 text-[40px] leading-none\" data-v-668b68a0></span></div><div data-v-668b68a0><h3 class=\"text-green-700 tracking-wide uppercase text-xs font-semibold\" data-v-668b68a0>Phones</h3><div class=\"mt-1 text-slate-800 font-medium text-[15px] leading-snug\" data-v-668b68a0><div data-v-668b68a0> BOOK A RIDE: <a class=\"hover:underline\" href=\"tel:+97332141440\" data-v-668b68a0>+973 3214 1440</a></div><div class=\"mt-1\" data-v-668b68a0> OFFICE: <a class=\"hover:underline\" href=\"tel:+97317001550\" data-v-668b68a0>+973 1700 1550</a></div></div></div></div><div class=\"flex items-start gap-4\" data-v-668b68a0><div class=\"relative shrink-0\" data-v-668b68a0><div class=\"w-12 h-12 rounded-full bg-white shadow-sm\" data-v-668b68a0></div><span class=\"font-icon theme-icon clock-icon text-slate-400 absolute -top-2 -left-1 text-[40px] leading-none\" data-v-668b68a0></span></div><div data-v-668b68a0><h3 class=\"text-green-700 tracking-wide uppercase text-xs font-semibold\" data-v-668b68a0>Working Hours</h3><p class=\"mt-1 text-slate-800 font-medium text-[15px] leading-snug\" data-v-668b68a0> 24/7 Available </p></div></div></div></div></section>", 1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(" © " + _toDisplayString(_unref(year)) + " ", 1),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-medium text-slate-600" }, "Vehitra Tech W.L.L", -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _createVNode(_unref(FontAwesomeIcon), {
                  icon: ['fab','facebook-f'],
                  class: "text-slate-600"
                })
              ]),
              _createElementVNode("a", _hoisted_9, [
                _createVNode(_unref(FontAwesomeIcon), {
                  icon: ['fab','instagram'],
                  class: "text-slate-600"
                })
              ]),
              _createElementVNode("a", _hoisted_10, [
                _createVNode(_unref(FontAwesomeIcon), {
                  icon: ['fab','x-twitter'],
                  class: "text-slate-600"
                })
              ]),
              _createElementVNode("a", _hoisted_11, [
                _createVNode(_unref(FontAwesomeIcon), {
                  icon: ['fab','linkedin-in'],
                  class: "text-slate-600"
                })
              ])
            ])
          ]),
          _createElementVNode("nav", null, [
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "text-slate-600 hover:text-slate-800 relative group",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'PrivacyPolicy' })))
                }, _cache[3] || (_cache[3] = [
                  _createTextVNode(" Privacy Policy "),
                  _createElementVNode("span", { class: "block h-[1px] w-0 bg-green-600 group-hover:w-full transition-all duration-300 -mb-0.5" }, null, -1)
                ]))
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "text-slate-600 hover:text-slate-800 relative group",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'TermsConditions' })))
                }, _cache[4] || (_cache[4] = [
                  _createTextVNode(" Terms & Conditions "),
                  _createElementVNode("span", { class: "block h-[1px] w-0 bg-green-600 group-hover:w-full transition-all duration-300 -mb-0.5" }, null, -1)
                ]))
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "https://blog.vehitraworld.com/",
                  target: "_blank",
                  rel: "noopener",
                  class: "text-slate-600 hover:text-slate-800 relative group"
                }, [
                  _createTextVNode(" Our Blog "),
                  _createElementVNode("span", { class: "block h-[1px] w-0 bg-green-600 group-hover:w-full transition-all duration-300 -mb-0.5" })
                ])
              ], -1))
            ])
          ]),
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"flex flex-col items-center md:items-end gap-3\" data-v-668b68a0><div class=\"text-[13px] md:text-[14px] text-slate-500\" data-v-668b68a0>Payments Supported</div><div class=\"flex flex-wrap items-center justify-center gap-2\" data-v-668b68a0><span class=\"pay-badge visa\" data-v-668b68a0>VISA</span><span class=\"pay-badge mc\" data-v-668b68a0>Mastercard</span><span class=\"pay-badge amex\" data-v-668b68a0>AmEx</span><span class=\"pay-badge mada\" data-v-668b68a0>Mada</span><span class=\"pay-badge apple\" data-v-668b68a0><svg viewBox=\"0 0 24 24\" class=\"h-4 w-4\" fill=\"currentColor\" aria-hidden=\"true\" data-v-668b68a0><path d=\"M16.365 1.43c0 1.14-.467 2.162-1.208 2.923-.772.8-2.03 1.415-3.141 1.33-.132-1.09.524-2.252 1.248-2.997.82-.846 2.203-1.47 3.101-1.256zM20.787 17.02c-.58 1.34-.865 1.93-1.614 3.115-1.046 1.655-2.52 3.72-4.32 3.74-1.016.01-1.716-.29-2.44-.6-.663-.288-1.35-.59-2.44-.6-1.134-.01-1.86.31-2.55.61-.7.31-1.35.6-2.366.61-1.8.02-3.176-1.78-4.22-3.43C-.012 17.94-.77 13.29 1.57 10.15c1.05-1.47 2.72-2.4 4.32-2.43 1.012-.02 1.96.34 2.68.65.68.29 1.29.55 2.16.54.83-.02 1.47-.28 2.15-.57.84-.36 1.71-.74 2.82-.63 1.18.12 2.15.5 2.88 1.15-1.27 1.16-1.14 3.21-.37 4.52.65 1.11 1.8 2.36 3.15 2.61-.33.98-.79 1.86-1.24 2.62z\" data-v-668b68a0></path></svg><span class=\"ml-1\" data-v-668b68a0>Apple Pay</span></span></div><div class=\"text-[13px] md:text-[14px] text-slate-500\" data-v-668b68a0> Developed by <a href=\"https://justrise.bh\" target=\"_blank\" rel=\"noopener\" class=\"text-green-700 font-medium hover:underline\" data-v-668b68a0> Just Rise Technologies </a></div></div>", 1))
        ])
      ])
    ])
  ]))
}
}

})